import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'formatoFecha'
})
export class FormatoFechaPipe implements PipeTransform {
  constructor() {
  }
    transform(value: any, formato = "DD/MM/YYYY h:mm:ss A"): any {
        if (value) {
            return moment(value).format(formato);
        }
        else return "00/00/0000";
    }
}
